import React, { useState, useEffect } from "react";
import { Pressable, StyleSheet, View, Text } from "react-native";
import { useSelector } from "react-redux";
import { useIsFocused, useFocusEffect } from "@react-navigation/native";

import GreenScreen from "@assets/svg/GreenScreen";
import RedScreen from "@assets/svg/RedScreen";
import Sales from "@assets/svg/SalesSelected";
import Commission from "@assets/svg/Commission";
import Ibutton1 from "@assets/svg/Ibutton1";
import Ibutton2 from "@assets/svg/IbuttonGrenn";
import colors from "@constants/color";
import { scale } from "@utils/scale";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import analytics from "@services/analytics";
import { SHOP_PERFORMANCE_EVENTS } from "@constants/analyticsEventsCT";
import SalesInfoCard from "./Components/salesInfoCard";

const PATH = "screens/ShopPerformance/Card";

const Card = ({
  showSaleCard,
  setSaleCard,
  showCommissionCard,
  setCommissionCard,
}) => {
  const isFocused = useIsFocused();

  useFocusEffect(
    React.useCallback(() => {
      if (!isFocused && (showSaleCard || showCommissionCard)) {
        setSaleCard(false);
        setCommissionCard(false);
      }
    }, [isFocused]),
  );
  const { sales, commissions, customerDetails } = useSelector(
    ({ shopPerformance }) => shopPerformance,
  );
  const { totalCommission, bonus, processed, processing } = commissions;
  const { deliveredSales, pendingSales, totalSales } = sales;

  function formatAmount(num) {
    return `${num}`.replace(/\B(?=(?:\d{3})+\b)/g, ",");
  }
  const showCommission = (customerCount) => {
    setTimeout(() => {
      analytics.trackEvent(SHOP_PERFORMANCE_EVENTS.INFO_VIEWED, {
        type: "commision",
        cx_count: customerCount,
      });
    }, 100);
    setCommissionCard(!showCommissionCard);
    setSaleCard(false);
  };

  const showSale = (customerCount) => {
    setTimeout(() => {
      analytics.trackEvent(SHOP_PERFORMANCE_EVENTS.INFO_VIEWED, {
        type: "sales",
        cx_count: customerCount,
      });
    }, 100);
    setSaleCard(!showSaleCard);
    setCommissionCard(false);
  };
  const GetSaleInfoData = ({
    key1,
    key2,
    value1,
    value2,
    info,
    salesInfo,
    commissionInfo,
  }) => {
    return (
      <View style={styles.ibuttonContainer}>
        <View style={styles.IbuttonCard}>
          <View>
            <Text style={styles.keys}>{key1}</Text>
            <Text style={styles.keys}>{key2}</Text>
          </View>
          <View>
            <View style={{ flexDirection: "row", marginLeft: 4 }}>
              <Text
                style={[
                  styles.value,
                  { fontFamily: "NotoSansDevanagari-Regular" },
                ]}
              >
                ₹
              </Text>
              <Text style={styles.value}>
                {value1 != 0 ? formatAmount(Number(value1).toFixed(1)) : 0}
              </Text>
            </View>
            <View style={{ flexDirection: "row", marginLeft: 4 }}>
              <Text
                style={[
                  styles.value,
                  { fontFamily: "NotoSansDevanagari-Regular" },
                ]}
              >
                ₹
              </Text>
              <Text style={styles.value}>
                {value2 != 0 ? formatAmount(Number(value2).toFixed(1)) : 0}
              </Text>
            </View>
          </View>
        </View>
        {commissionInfo && (
          <Text style={styles.info}>
            {t(`${PATH}/bonusCommission`)}
            <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}>
              {" "}
              ₹{bonus != 0 ? formatAmount(Number(bonus).toFixed(1)) : 0}
            </Text>{" "}
            {t(`${PATH}/received`)}
          </Text>
        )}
        {salesInfo && <Text style={styles.info}>{info}</Text>}
      </View>
    );
  };

  return (
    <View
      style={{
        backgroundColor: "#8691F4",
      }}
    >
      <View style={styles.container}>
        <View style={[styles.card1, { flex: 1 }]}>
          <View style={styles.salesCard}>
            <View style={{ padding: scale(16) }}>
              <View>
                <Text style={styles.text1}>{t(`${PATH}/sales`)}</Text>
              </View>
              <View style={styles.view}>
                <Text style={[styles.inr1, { color: "#FF7A00" }]}>₹</Text>
                <Text style={styles.text3}>
                  {formatAmount(parseInt(totalSales))}
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.icon}>
            <Sales width={32} height={32} />
          </View>
          <View style={styles.overlay}>
            <RedScreen />
          </View>
          <Pressable
            style={styles.Ibutton}
            onPress={() => {
              showSale(customerDetails.length);
            }}
            testID={testIds.ibutton1}
          >
            <Ibutton1 />
            <SalesInfoCard
              left={true}
              data={{}}
              style={{ left: -6 }}
              visible={showSaleCard}
            >
              <GetSaleInfoData
                salesInfo={true}
                key1={t(`${PATH}/delivered`)}
                key2={t(`${PATH}/processing`)}
                value1={deliveredSales}
                value2={pendingSales}
                info={t(`${PATH}/info1`)}
              />
            </SalesInfoCard>
          </Pressable>
        </View>

        <View style={[styles.card2, { flex: 1 }]}>
          <View style={styles.salesCard}>
            <View style={{ padding: scale(16) }}>
              <View>
                <Text style={[styles.text1, { color: "#00AB59" }]}>
                  {t(`${PATH}/productCommission`)}
                </Text>
              </View>
              <View style={styles.view}>
                <Text style={[styles.inr1, { color: "#00AB59" }]}>₹</Text>
                <Text style={[styles.text3, { color: "#00AB59" }]}>
                  {formatAmount(Number(bonus) + Number(totalCommission))}
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.icon}>
            <Commission width={32} height={32} />
          </View>
          <View style={styles.overlay}>
            <GreenScreen />
          </View>
          <Pressable
            style={styles.Ibutton}
            onPress={() => {
              showCommission(customerDetails.length);
            }}
            testID={testIds.ibutton2}
          >
            <Ibutton2 />

            <SalesInfoCard style={{ right: -6 }} visible={showCommissionCard}>
              <GetSaleInfoData
                commissionInfo={true}
                key1={t(`${PATH}/gotIt`)}
                key2={t(`${PATH}/processing`)}
                value1={processed}
                value2={processing}
                info={t(`${PATH}/info2`)}
              />
            </SalesInfoCard>
          </Pressable>
        </View>
      </View>
    </View>
  );
};

export default Card;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    borderTopEndRadius: 16,
    borderTopLeftRadius: 16,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  view: { flexDirection: "row", marginTop: 4 },
  ibuttonContainer: {
    flex: 1,
    justifyContent: "space-between",
    zIndex: 5000,
  },
  IbuttonCard: {
    flexDirection: "row",
    maxWidth: scale(100),
    justifyContent: "space-between",
  },

  card1: {
    borderRadius: 10,
    backgroundColor: "rgba(255, 122, 0, 0.05)",
    zIndex: 2000,
    flex: 1,
    minHeight: scale(122),
  },
  card2: {
    borderRadius: 10,
    backgroundColor: "rgba(0, 171, 89, 0.05)",
    flex: 1,
    marginLeft: 12,
    minHeight: scale(122),
  },
  overlay: {
    position: "absolute",
    bottom: 0,
    alignSelf: "flex-end",
    overflow: "hidden",
    borderBottomRightRadius: 10,
  },
  icon: {
    position: "absolute",
    right: scale(12),
    bottom: scale(12),
  },
  salesCard: { overflow: "hidden" },
  value: {
    fontSize: scale(12),
    fontFamily: "NotoSansDevanagari-Bold",
    marginLeft: 1,
  },
  keys: {
    fontSize: scale(12),
    fontFamily: "NotoSansDevanagari-Medium",
    color: "rgba(0, 0, 0, 0.56)",
  },
  info: {
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.56)",
    fontFamily: "NotoSansDevanagari-Regular",
    minWidth: scale(176),
  },
  view2: {
    width: "100%",
    position: "relative",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  text1: {
    color: "#FF7A00",
    fontSize: scale(16),
    lineHeight: scale(22),
    fontFamily: "NotoSansDevanagari-Medium",
  },
  text2: {
    color: "#00AB59",
    fontSize: scale(12),
    fontFamily: "NotoSansDevanagari-Regular",
  },
  text3: {
    color: "#FF7A00",
    fontSize: scale(24),
    lineHeight: scale(28),
    fontFamily: "NotoSansDevanagari-ExtraBold",
    maxWidth: 100,
  },
  inr1: {
    fontSize: scale(24),
    lineHeight: scale(28),
    color: "#00AB59",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  inr2: {
    fontSize: scale(14),
    color: "#00AB59",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  text4: {
    fontSize: scale(14),
    color: "#00AB59",
    fontFamily: "NotoSansDevanagari-Medium",
  },
  Ibutton: {
    position: "absolute",
    right: 4,
    padding: 10,
    top: scale(10),
  },
});
